import encode from 'encode-3986';

const isArray = (value: any) => Array.isArray(value) && value.length > 0;
const isString = (value: any) => typeof value === 'string' && value.length > 0;
const isNumber = (value: any) => typeof value === 'number' && value >= 0;

export const formQuery = (initial: any, params: any) => {
    if (!params) {
        return initial;
    }
    
    let baseQuery = initial;
    
    const entries = Object.entries(params);
    
    for (const [key, value] of entries) {
        const isFilledArray = isArray(value);
        const isFilledString = isString(value);
        const isFilledNumber = isNumber(value);
        
        if (!isFilledString && !isFilledNumber && !isFilledArray) {
            continue;
        }
        
        const query = getQuery({
            isFilledArray,
            value,
            baseQuery,
            key,
        });
        
        baseQuery = `${baseQuery}${query}`;
    }
    
    return baseQuery;
};

export const getQuery = (params: any) => {
    const {
        isFilledArray,
        value,
        baseQuery,
        key,
    } = params;
    
    if (isFilledArray) {
        return getArrayQuery(value, baseQuery, key);
    }
    const symbol = baseQuery.includes('?') ? '&' : '?';
    
    return getQueryString(symbol, key, value);
};

export const getQueryString = (symbol: any, key: any, value: any) => {
    return `${symbol}${key}=${encode(value)}`;
};

export const getArrayQuery = (param: any, path: any, key: any) => {
    let query = '';
    
    for (const value of param) {
        const symbol = query.includes('?') || path.includes('?') ? '&' : '?';
        const additionalQuery = getQueryString(symbol, key, value);
        
        query = `${query}${additionalQuery}`;
    }
    
    return query;
};
